export default "__VITE_ASSET__Dfq0lPSl__"